<span *ngIf="animatePriceChange" [countUp]="currentCryptoExchangeRate" [options]="countUpOptions">{{initialCryptoExchangeRateFormatted}}</span>
<span *ngIf="!animatePriceChange">{{currentCryptoExchangeRateFormatted}}</span>
